export const accountsTypes = [
  { value: 'CHECKING', label: 'Conta Corrente' },
  { value: 'SAVINGS', label: 'Conta Poupança' },
  { value: 'PAYMENT', label: 'Conta de Pagamento' },
  { value: '', label: '' },
];
